import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({

  categories: {
      necessary: {
          enabled: true,  // this category is enabled by default
          readOnly: true  // this category cannot be disabled
      },
      analytics: {}
  },

  language: {
      default: 'cs',
      translations: {
          cs: {
            consentModal: {
                title: 'Používáme cookies',
                description: 'Používáme cookies pro zajištění správného fungování webu, zlepšení uživatelské zkušenosti a analýzu návštěvnosti. Nastavení můžete kdykoliv změnit.',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Odmítnout vše',
                showPreferencesBtn: 'Spravovat individuální preference'
            },
            preferencesModal: {
                title: 'Správa předvoleb cookies',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Odmítnout vše',
                savePreferencesBtn: 'Přijmout aktuální výběr',
                closeIconLabel: 'Zavřít okno',
                sections: [
                    {
                        title: 'Někdo řekl ... cookies?',
                        description: 'Chci jednu!'
                    },
                    {
                        title: 'Nezbytné cookies',
                        description: 'Tyto cookies jsou nezbytné pro správné fungování webu a nelze je vypnout.',
                        linkedCategory: 'nezbytné'
                    },
                    {
                        title: 'Výkon a analýza',
                        description: 'Tyto cookies shromažďují informace o tom, jak používáte náš web. Všechna data jsou anonymizována a nelze je použít k vaší identifikaci.',
                        linkedCategory: 'analytika'
                    },
                    {
                        title: 'Více informací',
                        description: 'Pro jakékoliv dotazy týkající se naší politiky cookies a vašich možností nás prosím <a href="#contact-page">kontaktujte</a>'
                    }
                ]
            }
          }
      }
  }
});
